<!-- Loading Bar -->
 <ng2-slim-loading-bar [color]="'Cyan'" [height]="'4px'"></ng2-slim-loading-bar>

 <!-- Page Layout Start -->
 <!-- ---------------------------------------------------- -->
 <router-outlet></router-outlet> 
 <!-- ---------------------------------------------------- -->


